$(document).ready(function () {

    $('.tab-btn').on('click', function () {
      var tabId = $(this).data('tab');

      $('.tab-btn').removeClass('active');
      $(this).addClass('active');

      $('.tab-content').removeClass('active');
      $('#' + tabId).addClass('active');
    });


    $('.read-more-btn').on('click', function () {
      var content = $(this).siblings('.read-more-content');

      content.toggleClass('expanded');

      if (content.hasClass('expanded')) {
        $(this).text('weniger anzeigen');
      } else {
        $(this).text('weiterlesen…');
      }
    });

  });